import { Controller } from "stimulus"
export default class extends Controller {
  static targets = [ "mo_form" ]

  autosubmit() {
    this.mo_formTarget.requestSubmit();
  }
}
